import {createReducer, on} from "@ngrx/store";
import { userInitialState } from "./user.state";
import {userTokenFetchAction} from "./user.actions";

export const userReducer = createReducer(userInitialState,
    on(userTokenFetchAction, (state, {user, token}) => (
        {...state, userInfo: user, userToken: token}
    ))
);
